import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const RecapLeaveService = {

    async liste(month,year){
        try {
            const result = await axios.post(`${apiUrl}/recapLeave`,{
                month:month,
                year:year
            } );
            if (result) {
              return result.data;
            }
          } 
          catch (error) {
            if (error.response) {
              return error.response.data;
            }
          }
    },
    async excel(month,year){
        try {
            const result = await axios.post(`${apiUrl}/recapLeave/getexportleave`,{
                month:month,
                year:year
            } );
            if (result) {
              return result.data;
            }
          } 
          catch (error) {
            if (error.response) {
              return error.response.data;
            }
          }
    },
      async history(){
        try {
            const result = await axios.get(`${apiUrl}/recapLeave` );
            if (result) {
              return result.data;
            }
          } 
          catch (error) {
            if (error.response) {
              return error.response.data;
            }
          }
    },


  }

export default RecapLeaveService;